import { createSelector } from 'reselect';
import { experienceSelector } from 'selectors/testTarget/offers/biSignInUpAccountCopyUpdate/experience/experienceSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { BI_SIGN_IN_UP_ACCOUNT_COPY } from 'constants/TestTarget';

const showBiSignInUpAccountCopyUpdateSelector = createSelector(isTestTargetReadySelector, experienceSelector, (testReady, experience) => ({
    challengerOne: testReady && experience === BI_SIGN_IN_UP_ACCOUNT_COPY.CHALLENGER_ONE,
    challengerTwo: testReady && experience === BI_SIGN_IN_UP_ACCOUNT_COPY.CHALLENGER_TWO
}));

export { showBiSignInUpAccountCopyUpdateSelector };
